export default __webpack_public_path__ + "static/paleto_bay_forgery-88b1fed4469159a5a60128bd204f0e56.png";